<dx-popup [width]="900" [height]="840" title="Edit Plant Volumes" [showTitle]="true" [dragEnabled]="true"
    [closeOnOutsideClick]="false" [(visible)]="volumePopupVisible">
    <div *dxTemplate="let data of 'content'" #popupContent style="overflow-y: auto; height: 100%; padding: 10px;" (wheel)="onPopupWheel($event)">
        <div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Plant Volume History</h5>
                    <dx-data-grid id="gridContainer" [dataSource]="dataSource" keyExpr="siteId"
                        [allowColumnReordering]="true" [showRowLines]="true" [showColumnLines]="true"
                        [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
                        [columnHidingEnabled]="false" [allowColumnResizing]="false">
                        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                        <dxi-column dataField="prodGas" caption="Product"></dxi-column>
                        <dxi-column dataField="insertedDate" caption="On"></dxi-column>
                        <dxi-column dataField="volume" caption="Volume"></dxi-column>
                        <dxi-column dataField="prodVolUom" caption="UOM"></dxi-column>
                        <dxi-column dataField="prodvolreason" caption="Reason"></dxi-column>
                        <dxi-column dataField="onstreamDate" caption="Onstream Date"
                            format="yyyy-MM-ddT00:00:00"></dxi-column>
                        <dxi-column dataField="expansionDate" caption="Expansion Date"></dxi-column>
                        <dxi-column dataField="volumeSource" caption="Source"></dxi-column>
                        <dxi-column dataField="comments" caption="Comments"></dxi-column>
                        <dxi-column dataField="insertedBy" [visible]="false" caption="Inserted By"></dxi-column>
                        <dxi-column dataField="modifiedBy" [visible]="false" caption="Modified By"></dxi-column>
                        <dxi-column dataField="modifiedDate" [visible]="false" caption="Modified On"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>
            <div class="topmargin leftfloat">
                <dx-button class="ap-blue-btn btnEntry" (onClick)="addNewEntry()" text="Add New Entry">
                </dx-button>
                <p class="red leftmargin">Note: Only the newest value for each product is used in further calculations.
                    If there is an expansion, use the new total volume, not incremental change.</p>
            </div>
            <div class="card">
                <form #facilityForm="ngForm" class="form-horizontal" (ngSubmit)="OnDoneClicked()" autocomplete="off"
                    showValidationSummary="true">
                    <dx-validation-group>
                        <div *ngIf="isNewEntryClicked" class="card-body">
                            <h5 class="card-title">New Entry</h5>
                            <div class="table-responsive">
                                <table class="col-md-12">
                                    <tr class="maxheight">
                                        <td><span class="bold">Product</span><span class="red">*</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-select-box #selectBox
                                                            (onValueChanged)="onValueChanged($event)"
                                                            [dataSource]="productDataSource" [acceptCustomValue]="true"
                                                            displayExpr="name" valueExpr="name"
                                                            [(value)]="NewProdEntry.prodGas" [searchEnabled]="true">
                                                            <dx-validator>
                                                                <dxi-validation-rule type="required"
                                                                    message="Product is required">
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        </dx-select-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span class="bold">Volume</span><span class="red">*</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value leftfloat">
                                                        <dx-text-box style="width: 48%;"
                                                            [(value)]="NewProdEntry.volume">
                                                            <dx-validator>
                                                                <dxi-validation-rule type="required"
                                                                    message="Volume is required">
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        </dx-text-box>
                                                        <dx-select-box class="leftmarginreason" #selectBox
                                                            [dataSource]="ProductUnitsDataSource"
                                                            [acceptCustomValue]="true" displayExpr="name"
                                                            valueExpr="name" [(value)]="NewProdEntry.prodVolUom"
                                                            [searchEnabled]="true">
                                                            <dx-validator>
                                                                <dxi-validation-rule type="required"
                                                                    message="Volume UOM is required">
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        </dx-select-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span>Reason for Entry</span><span class="red">*</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-select-box #selectBox [dataSource]="ReasonsDataSource"
                                                            [acceptCustomValue]="true" displayExpr="reason"
                                                            valueExpr="reason" [(value)]="NewProdEntry.prodvolreason"
                                                            [searchEnabled]="true">
                                                            <dx-validator>
                                                                <dxi-validation-rule type="required"
                                                                    message="Reason for Entry is required">
                                                                </dxi-validation-rule>
                                                            </dx-validator>
                                                        </dx-select-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr [hidden]="!isSourceTypeVisible" class="maxheight">
                                        <td><span>Source Type</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-select-box name="supplyType" id="supplyType"
                                                            [items]="SourceTypeDataSource" displayExpr="listItem"
                                                            valueExpr="listItem" [showClearButton]="true"
                                                            [(value)]="NewProdEntry.supplyType">
                                                        </dx-select-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span>Source of Data Note</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-text-box
                                                            [(value)]="NewProdEntry.volumeSource"></dx-text-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span>OnStreamDate (YYYY/MM)</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-date-box [(value)]="NewProdEntry.onstreamDate"
                                                            displayFormat="monthAndYear"></dx-date-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span>Expansion Date (YYYY/MM)</span></td>
                                        <td>
                                            <div>
                                                <div class="dx-field">
                                                    <div class="dx-field-value">
                                                        <dx-date-box [(value)]="NewProdEntry.expansionDate"
                                                            displayFormat="monthAndYear"></dx-date-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="maxheight">
                                        <td><span>Comments</span></td>
                                        <td>
                                            <table style="width: 100%;">
                                                <tr>
                                                    <td style="width: 60%;">
                                                        <div>
                                                            <dx-text-box
                                                                [(value)]="NewProdEntry.comments"></dx-text-box>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="leftfloat">
                                                            <dx-button class="ap-blue-btn  mr-1 mt-1 ml-2 px-3"
                                                                [useSubmitBehavior]="true" text="Done">
                                                            </dx-button>
                                                        </div>
                                                        <div class="leftfloat">
                                                            <dx-button class="ap-blue-btn  mr-1 mt-1 ml-2 px-3"
                                                                text="Cancel" (onClick)="OnCancelclicked()">
                                                            </dx-button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="topmargin text-center">
                            <dx-validation-summary></dx-validation-summary>
                        </div>
                    </dx-validation-group>
                </form>
            </div>

            <div class="topmargin mb-3">
                <div class="col-md-12 text-center">

                    <dx-button [disabled]="!isNewProdVolEntryAdded" class="ap-green-btn mr-1 mt-1 ml-2 px-5"
                        text="Save Close" (onClick)="OnSaveCloseClicked()">
                    </dx-button>
                    <dx-button class="ap-discard-button mr-1 mt-1 ml-2 px-5" text="Discard Close"
                        (onClick)="OnDiscardCloseClicked()">
                    </dx-button>

                </div>
            </div>
        </div>
    </div>
</dx-popup>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>